export default {
  submit: '提 交',
  save: '保 存',
  close: '關閉',
  loading: "處理中...",
  header: {
    allProduct: "商品分類",
    searchPlaceholder: "請輸入搜索內容",
    accountOrder: "我的訂單",
    accountCollect: "我的收藏",
    accountIntegral: "我的點數",
    accountCoupon: "我的優惠券",
    logout: "退出登錄",
    hotRecommend: '熱門推薦',
    searchHistory: '搜索記錄',
    empty: '清空',
    more: '更多'
  },
  page: {
    pagesize: '条/页',
    goto: '前往',
    pageClassifier: '页',
    total: '共 {total} 条'
  },
  image: {
    error: '加載失敗'
  },
  upload: {
    deleteTip: '刪除'
  },
  selectRegion: {
    userAddressTitle: "常用地址",
    selectAddressTitle: "選擇地址"
  },
  yes: '是',
  no: '否',
  sellOff: '處分品',
  verticalReductionActivity: '滿減',
  discountActivity: '滿折',
  verticalReductionActivityCoupon: '滿減券',
  discountActivityCoupon: '滿折券',
  freeShippingyCoupon: '運費抵用券',
  addShoppingCart: '加入購物車',
  pointNumber: '{productPointNum}倍積分',
  stockout: '補貨中',
  edit: '編輯',
  delete: '刪除',
  pleaseSelect: '請選擇',
  pleaseInput: '請輸入',
  confirm: '確定',
  cancel: '取消',
  detail: '详情',
  productName: '商品名稱',
  productNo: '商品編號',
  specification: '規格',
  orderNo: '訂單編號',
  amount: '數量',
  productPrice: '單價',
  subtotal: '商品金額小計',
  productSubtotal: '商品金額小計',
  coupon: '優惠券',
  freight: '運費',
  totalPrice: '合計',
  prompt: '提示',
  orderStatus1: "待支付",
  orderStatus2: "待處理",
  orderStatus3: "出貨準備中",
  orderStatus4: "出貨準備中",
  //拣货中,前台不显示这个状态
  orderStatus5: "已出貨",
  orderStatus6: "已完成",
  orderStatus7: "已取消",
  commonHint: '提醒',
  noRecord: '沒有記錄哦！',
  addCartSuccess: '加入購物車成功',
  unSet: '不指定',
  beforeNoon: '午前',
  captchaSentSuccessfully: '驗證碼發送成功',
  OYX: '驗證通過',
  updateSuccessfully: '更新成功',
  addSuccessfully: '新建成功',
  deleteSuccessfully: '刪除成功',
  thousand: '千',
  tenThousand: '萬',
  fastTimeRecive: '最短时间送达',
  selectReciveDate: '請選擇指定收貨時間',
  couponList: '優惠券列表',
  footer: {
    informationConsultantTitle: "關於我們",
    informationConsultant1: "優惠券使用方法",
    informationConsultant2: "大量採購",
    informationConsultant3: "常見問題",
    informationConsultant4: "便利商店付款",
    informationConsultant5: "供應商募集",
    shoppingRelatedTitle: "購物相關",
    shoppingRelated1: "每月特惠",
    shoppingRelated2: "點數介紹",
    shoppingRelated3: "購物須知",
    customerServiceTitle: "客戶服務",
    customerService1: "歷史訂單",
    customerService2: "收藏列表",
    customerService3: "訂閱資訊",
    otherTitle: "其他",
    other1: "關於我們",
    footer1: "條款和條件",
    footer2: "特定商取引法",
    footer3: "隱私政策"
  },
  timeOutTip: "請求超時",
  no_coupon: '暫無優惠券',
  no_existence_coupon: '該優惠券不存在',
  information: "文章",
  accessPasswordNull: '請輸入訪問密碼',
  indexPage: '首頁',
  check_article_exist: "該文章不存在",
  offShelves: "已下架",
  levelUpTip1: "當前您訪問的是本味主義測試站點，請點擊",
  levelUpTip2: "跳轉到正式站點",
  bunding: '同捆'
};